module.exports = "<div class=\"nav-expander\" (click)=\"expanded = !expanded\">\n  <img src=\"../../../assets/images/menu.png\" />\n</div>\n\n<div class=\"nav\" [ngClass]=\"expanded ? 'expanded' : 'collapsed'\">\n  <ul>\n    <li *ngFor=\"let link of links\" (click)=\"navigate(link.link)\">\n      <a>{{link.title}}</a>\n    </li>\n  </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/nav/nav.component.html
// module id = ./src/app/components/nav/nav.component.html
// module chunks = main